module.exports = __webpack_public_path__ + "img/im3.407de776.png";